import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SortPipe } from 'app/Shared/Component/pipes/sort.pipe';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { EmitterService } from 'app/Shared/Services/emitter.service';
import { GridService } from 'app/Shared/Services/grid.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { asBlob, generateCsv } from 'export-to-csv';
import { MessageService, ConfirmationService } from 'primeng/api';
import { map } from 'rxjs';
import {default as GridColumnsJSON} from './Broker-Mapping-Grid-Columns.json';
import { BrokerMapping } from './broker-mapping.model';
import { BrokerMappingService } from './broker-mapping.service';
import { DatePipe, LowerCasePipe, NgClass, CommonModule } from '@angular/common';
import { TableModule, Table } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import saveAs from 'file-saver';
import { FilterPanelComponent } from "../../../Shared/Component/filter-panel/filter-panel.component";
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { AddBrokerMappingComponent } from './add-broker-mapping/add-broker-mapping.component';
import { ViewBrokerMappingComponent } from "./view-broker-mapping/view-broker-mapping.component";
import { EditBrokerMappingComponent } from "./edit-broker-mapping/edit-broker-mapping.component";
import { ToastModule } from 'primeng/toast';
import { QuickSearchComponent } from "../../../Shared/Component/quick-search/quick-search.component";
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu';
import { GridCommonService } from 'app/Shared/Services/grid-common.service';

@Component({
    selector: 'app-broker-mapping',
    templateUrl: './broker-mapping.component.html',
    styleUrls: ['./broker-mapping.component.scss'],
    imports: [CommonModule, TableModule, ButtonModule, FormsModule,ContextMenuModule,
        FilterPanelComponent, MatProgressSpinnerModule, NgClass, LowerCasePipe, DatePipe,
        MatTooltipModule, ConfirmDialogModule, AddBrokerMappingComponent, ViewBrokerMappingComponent,
        EditBrokerMappingComponent, ToastModule, QuickSearchComponent]
})
export class BrokerMappingComponent implements OnInit, OnDestroy {
  @ViewChild(('dt')) dt!: Table |any;
   @ViewChild('cm') contextMenuItems!: ContextMenu;
  GridColumns = GridColumnsJSON;
  columns: any = [];
  public tbldatamsg = 'L o a d i n g . . . . .';
  emptytbldatamsg = "Data not found";
  subscription: any;
  selectedRow: any = [];
  sortData: any = { field: '', order: 0 };
  sortClickCounter: number = 0;
  isExportToCSV = false;
  cols: any = [];

  quickFilterArray:any;

  constructor(
    private urlsService: UrlsService,
    public userService: UserService,
    private gridService: GridService,
    private emitterService: EmitterService,
    public constantService: ConstantService,
    private messageService: MessageService,
    public brokerMappingService: BrokerMappingService,
    private sortPipe: SortPipe,
    private confirmationService: ConfirmationService,
    public commonColService:GridCommonService) {
    this.brokerMappingService.rowcount = this.constantService.DEFAULT_ROWSIZE;
  }

  onView(ri:any, selectedRow:any) {
    this.brokerMappingService.isView = true;
    this.selectedRow = [selectedRow];
  }


  onAdd() {
    this.brokerMappingService.isAdd = true;
    this.brokerMappingService.addRow = null;
    this.brokerMappingService.addRow = new BrokerMapping();
    this.brokerMappingService.addRow.AffiliateFlag = "N";
    this.brokerMappingService.addRow.createdDate = this.userService.getDateTimeFormate(new Date());
    this.brokerMappingService.addRow.updatedDate = this.userService.getDateTimeFormate(new Date());
    this.brokerMappingService.addRow.createdUser = this.userService.getUserName();
    this.brokerMappingService.addRow.updatedUser = this.userService.getUserName();
  }

  onEdit(ri:any, selectedRow:any) {
    this.brokerMappingService.editRow = JSON.parse(JSON.stringify(selectedRow));
    this.brokerMappingService.isEdit = true;
  }

  onDelete(ri:any, selectedRow:any) {
    this.confirmationService.confirm({
      message: 'Do you want to delete this record?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptLabel: 'Yes',
      acceptIcon:'pi pi-check',
      rejectLabel: 'No',
      rejectIcon:'pi pi-times',
      acceptButtonStyleClass:"broker-map-confirm-dialog-button",
      rejectButtonStyleClass:"broker-map-confirm-dialog-button",
      accept: () => {
        this.brokerMappingService.isLoadingResults = true;
        let payload = {
          "mpid": this.userService.getActiveMPID(),
          "customerID": selectedRow['CustomerID'],
          "firmMPID": selectedRow['FirmMPID'],
          "id": selectedRow['id'],
          "user": this.userService.getUserName(),
        }
        this.brokerMappingService.getDelete(payload)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (data: any) => {
              this.brokerMappingService.isLoadingResults = false;
              if (data.status) {
                this.getData();
                this.messageService.add({ severity: 'info', summary: 'Confirmed', detail: 'Record deleted' });
                this.messageService.add({ severity: 'success', summary: 'Update Success Message', detail: data.data });
              } else {
                this.messageService.add({ severity: 'error', summary: 'Update Success Message', detail: data.data });
              }
            },    
            error: (err: HttpErrorResponse) => {
              this.brokerMappingService.isLoadingResults = false;
            }
          });  
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Cancelled', detail: 'Action cancelled' });
      }
    });
  }

  changePage(event:any) {
    this.brokerMappingService.startLimit = event.first;
    this.brokerMappingService.rowcount = event.rows;
    this.brokerMappingService.endLimit = this.brokerMappingService.startLimit + this.brokerMappingService.rowcount;
    if (this.brokerMappingService.endLimit > this.brokerMappingService.totalRecords) {
      this.brokerMappingService.endLimit = this.brokerMappingService.totalRecords;
    }
    this.getData();
  }

  ngOnInit(): void {
    this.brokerMappingService.endLimit = this.brokerMappingService.rowcount;
    this.subscription = this.emitterService.reloadMainDashBoard.subscribe(value => {
      if (value) {
        this.getData();
      }
    });
    this.getColumns();
    this.brokerMappingService.defaultFiltter();
    this.getData();

    this.quickFilterArray = [
      {
        label: 'customerID', columnname: 'customerID', placeholder: 'Customer ID',
        width: '', datatype: 'String'
      },
      {
        label: 'receivedFromMPID', columnname: 'receivedFromMPID', placeholder: 'Received From MPID',
        width: '', datatype: 'String', isLarge: true
      },      
    ];
    this.cols = [...this.GridColumns];
     this.commonColService.init(this.cols, 'Broker-Map');
  }



  getColumns() {
    let column: any;
    column = this.GridColumns;
    this.columns = this.GridColumns.filter((col: any) => col.ui_columnname !== "Action");
    if (column !== null || column !== undefined) {
      this.GridColumns = this.gridService.getGridColumns(column);
    }
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  getData() {
    this.brokerMappingService.reloadData();
  }

  FilterApplyFilterEvent(event:any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.brokerMappingService.DefaultFilterArray = [];
    this.brokerMappingService.DefaultFilterArray = event;
    this.brokerMappingService.startLimit = 0;
    this.brokerMappingService.endLimit = this.brokerMappingService.rowcount
    this.getData();
  }

  sort(event:any) {
    if (this.commonColService.isCtrlPressed|| this.commonColService.isDragging || this.commonColService.selectedFields.length > 1) {
    this.dt.multiSortMeta =[];
    this.dt.sortField = '';
    this.dt.sortOrder = 0;
    return;
     }
    if (event.multisortmeta[0].field != "") {
      if (this.sortClickCounter !== 3 && (this.sortData.field === "" || this.sortData.field === event.multisortmeta[0].field)) {
        this.sortClickCounter = this.sortClickCounter + 1;
      } else {
        this.sortClickCounter = 1;
      }
      if (this.sortClickCounter !== 3) {
        let sortOrder = event.multisortmeta[0].order === 1 ? 'asc' : 'desc';
        this.sortData.field = event.multisortmeta[0].field;
        this.sortData.order = sortOrder;
        this.brokerMappingService.dataset = this.sortPipe.transform(this.brokerMappingService.dataset, this.sortData.order, this.sortData.field);
      } else {
        this.resetSort();
      }
    }
  }
  resetSort() {
    this.dt.multiSortMeta[0].field = 'abc';
    this.dt.multiSortMeta[0].order = 0;
    this.brokerMappingService.dataset = this.brokerMappingService.defaultData;
  }


  exportToCSV() {
    if(this.userService.enableFileExport()){
    let initialTime = new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

    this.messageService.add({ severity: 'info', summary: 'File', detail: 'Please wait.. Preparing export file to download..' });
    this.isExportToCSV = true;
    const filename = 'RSMS_BrokerMaping_' + this.userService.getyyyyMMddDateFormate(new Date());
    let payload = {
      "mpid": this.userService.getActiveMPID(),
      "data": this.brokerMappingService.DefaultFilterArray,
      "startLimit": 0,
      "endLimit": this.brokerMappingService.totalRecords
    }
    this.brokerMappingService.getData(payload)
      .pipe(map((response: Response) => {
        return response;
      }))      
      .subscribe({
        next: (dataset: any) => {
          this.isExportToCSV = false;
            let data = dataset.data;
            if (data.length > 0) {
              const options:any = {
                fieldSeparator: ',',
                quoteStrings: '"',
                decimalSeparator: '.',
                showLabels: true,
                showTitle: true,
                title: filename,
                useTextFile: false,
                useBom: true,
                useKeysAsHeaders: true,
                filename: filename
              };
              const csv = generateCsv(options)(this.constantService.getExportData(data, GridColumnsJSON));
              const blob = asBlob(options)(csv);
              saveAs(blob, filename);
              this.messageService.add({ severity: 'success', summary: 'File', detail: 'File Download Successfully' });
              this.userService.logUserActivity('Export CSV ' + filename, null, {
                'Text1': 'File Download Successfully | ' + (data.length > 0 ? data.length : 0) + ' records downloaded with file name: ' + options.filename + ' with start time: ' + initialTime + ' and end time: ' + new Date().toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit' }),
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.brokerMappingService.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            } else {
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'No data found' });
              this.userService.logUserActivity('Export CSV ' + filename, null, {
                'Text1': 'No data found',
                'Text2': 'User Filter Parameters: ' + JSON.stringify(this.brokerMappingService.DefaultFilterArray.filter((filterParam:any) => (filterParam.values != '' || filterParam.values.length > 0)))
              });
            }
        },
        error: (err: HttpErrorResponse) => {
          this.isExportToCSV = false;
        }
      });  
    }
  }

  updateDefaultArray($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.brokerMappingService.DefaultFilterArray = $event;
    this.brokerMappingService.startLimit = 0;
    this.brokerMappingService.endLimit = this.brokerMappingService.rowcount;
    this.getData();
  }

  clearQuickSearch($event: any) {
    this.emitterService.isResetGridLimit.emit(true);
    this.brokerMappingService.DefaultFilterArray = $event;
    this.brokerMappingService.startLimit = 0;
    this.brokerMappingService.endLimit = this.brokerMappingService.rowcount;
    this.getData();
  }

}
